/**
 * Language registry.
 *
 * `launched: true` means the language is ready for users — it shows up in the
 * Settings picker. Unlaunched languages can still be selected for development
 * (e.g. `?lng=de` or by flipping the flag locally) because they remain in
 * `supportedLngs`, but the UI won't surface them.
 *
 * Adding a `src/locales/<code>/` folder is **not** enough to launch — flip
 * `launched` here too.
 *
 * `label` is the native name (e.g. "Deutsch", not "German"), shown as-is
 * regardless of UI language so users can recognize their own.
 */
export interface LanguageConfig {
  code: string;
  label: string;
  launched: boolean;
}

export const LANGUAGES: ReadonlyArray<LanguageConfig> = [
  { code: 'en', label: 'English', launched: true },
  { code: 'de', label: 'Deutsch', launched: false },
];

export const SUPPORTED_LANGUAGE_CODES: ReadonlyArray<string> = LANGUAGES.map((l) => l.code);

export const LAUNCHED_LANGUAGES: ReadonlyArray<LanguageConfig> = LANGUAGES.filter(
  (l) => l.launched,
);
